// The one place the site's customer rating lives (PS-56). Every rating display
// renders from these values; nothing else in the repo may hard-code a score.
//
// Internal provenance - deliberately NOT exported and never rendered. The
// source is not named on the site and no rating display links to a review
// site; update both fields whenever the value changes.
// eslint-disable-next-line no-unused-vars
const SOURCE = 'Trustpilot'
// eslint-disable-next-line no-unused-vars
const AS_OF = '2026-10-08'

export const RATING_VALUE = 4.4
export const RATING_LABEL = 'Excellent'

// "Excellent · 4.4 out of 5" - the standard wording.
export const RATING_TEXT = `${RATING_LABEL} · ${RATING_VALUE} out of 5`

// "Excellent · 4.4/5" - for tight spots only (nav drawer, funnel badges).
export const RATING_TEXT_SHORT = `${RATING_LABEL} · ${RATING_VALUE}/5`

// The accessible name RatingStars gives itself.
export const RATING_ARIA_LABEL = `Rated ${RATING_VALUE} out of 5`
